import { f as a } from "./addOns-5IZhcbHD.js";
const o = {
  id: "FloridaPick3",
  name: "Pick 3",
  style: {
    colorPrimary: "#f88d2a",
    fireball: a
  }
};
export {
  o as default
};
